export default [
  {
    path: '/invitation/verify',
    name: 'invitation/verify',
    component: () => import('@/views/invitation/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      pageTitle: 'breadcrumb.welcome',
      redirectIfLoggedIn: false,
    },
  },
]
